export default {
  app: {
    notFound: {
      title: '找不到網頁。',
      subtitle: '看來您迷路了。',
      text: '不用擔心，我們將幫助您從這裡導航',
    },
  },
};
